<template>
  <el-container class="body-container">
    <el-header style="height: 56px;padding-left: 0; display: flex;align-items: center;justify-content: space-between;width: 1020px;max-width: 1020px;margin: 0 auto;padding-right: 0;">
      <div style="font-size: 20px;color: #59575f;font-weight: bold;height: 30px;line-height: 30px;">{{ title  }}</div>
      <el-button type="primary" size="mini" @click="closeWindow">返回</el-button>
    </el-header>
    <el-main class="new-main">
      <div class="new-table">
        <el-table
          :data="newsListData"
          ref="newsList"
          border
          highlight-current-row
          :header-cell-style="{'background-color':'#b8b1b0','color':'#3d3533', 'font-weight':'500', 'text-align':'center', 'font-size':'14px'}"
          @row-click="goDetail"
          stripe
        >
          <el-table-column prop="title" label="标题">
            <template slot-scope="scope">
              <div class="cursor_point">{{ scope.row.title }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="publishTime" align="center" :formatter="changeDate" label="发布时间" width="120px"></el-table-column>
        </el-table>
        <el-col :span="24" style="display: flex; justify-content: end;margin-top: 10px;">
          <table-page
            ref="newsListPage"
            :url="newsListUrl"
            :form="form"
            :urlDafault="true"
            @page-change="convert"
          ></table-page>
      </el-col>
      </div>
      <!-- <div class="footCss"></div> -->
    </el-main>
  </el-container>
</template>

<script>
import TablePage from "@/components/TablePage";

import moment from "moment";
export default {
  name: 'newsList',
  data() {
    return {
      newsListUrl: this.global.CMS_BASE+'/article/findWebNotice',
      newsListData: [],
      form: {
        status: 50,
      },
      title:''
    }
  },
  components: {
    TablePage,
  },
  methods: {
    closeWindow(){
      window.close()   
    },
    goDetail(row, column) {
      const route = this.$router.resolve({ path: `/news/${row.articleId}`  });
      window.open(route.href, '_blank');
    },
    search(param) {
      this.$refs["newsListPage"].getTableData(param);
    },
    convert(tableData) {
      this.newsListData = tableData.data;
    },
    changeDate(row, column) {
      let date = row[column.property]
      if (date) {
        return moment(date).format("YYYY-MM-DD");
      }
      return "";
    },
  },
  created() {
    console.log(this.$route) 
    if (this.$route.params.type == 'head') {
      this.title = '焦点头条'
      this.form.category = 'focus'
    } else if(this.$route.params.type == 'new'){
      this.title = '动态新闻'
      this.form.category = 'new'
    } else if(this.$route.params.type == 'notice'){
      this.title = '通知公告'
      this.form.category = 'notice'
    }
    this.search()
  },
  mounted() {
    let dom = document.getElementsByClassName('body-container')[0]
    let app = document.getElementById('app')
    dom.style.height = app.style.minHeight
    console.log(app,dom)
  },
}
</script>

<style lang="less" scoped>
  .new-main {
    width: 1020px;
    max-width: 1020px;
    margin: 0 auto;
    padding: 0;
  }
  .new-table{
    background-color: rgb(255, 255, 255);
    padding: 26px 26px 66px;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.03) 0px 0px 8px 0px;
  }
  .footCss {
    position: absolute;
    bottom: 0;
    width: 1210px;
    margin: 0 auto;
    left: 0;
    right: 0;
    height: 146px;
    box-sizing: border-box;
    background: url(../../assets/images/red-footer-background.png) no-repeat;
    background-size: 100% 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/main/newsList.vue